/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line
  
  // Verificar configuración básica del carrito
  if (!window.theme?.settings?.cartType) {
    if (window.theme && window.theme.settings) {
      window.theme.settings.cartType = 'drawer'; 
    }
  }

  // === OPTIMIZACIONES DE PERFORMANCE ===
  
  // Optimización 1: Lazy load de Swym solo en páginas que lo necesiten
  function initSwymLazy() {
    if (document.querySelector('.swym-button, [class*="swym"]') || 
        window.location.pathname.includes('/products/') ||
        window.location.pathname.includes('/account')) {
      // Solo cargar Swym si hay elementos que lo necesiten
      if (window.swymPageLoad && typeof window.swymPageLoad === 'function') {
        window.swymPageLoad();
      }
    }
  }
  
  // Optimización 2: Defer de scripts de terceros hasta user interaction
  let userInteracted = false;
  function onFirstInteraction() {
    if (!userInteracted) {
      userInteracted = true;
      console.log('🚀 User interaction detected, loading deferred scripts');
      initSwymLazy();
    }
  }
  
  // Listeners para primera interacción
  ['click', 'scroll', 'keydown', 'touchstart'].forEach(event => {
    document.addEventListener(event, onFirstInteraction, { once: true, passive: true });
  });
  
  // Optimización 3: Performance monitoring
  function logPerformance() {
    if (window.performance && window.performance.timing) {
      const timing = window.performance.timing;
      const loadTime = timing.loadEventEnd - timing.navigationStart;
      console.log(`📊 Page load time: ${loadTime}ms`);
      
      // Log slow resources
      const resources = window.performance.getEntriesByType('resource');
      const slowResources = resources.filter(r => r.duration > 500);
      if (slowResources.length > 0) {
        console.warn('🐌 Slow resources detected:', slowResources);
      }
    }
  }
  
  // Monitor performance after load
  if (document.readyState === 'complete') {
    setTimeout(logPerformance, 1000);
  } else {
    window.addEventListener('load', () => setTimeout(logPerformance, 1000));
  }
  
  // Optimización 4: Lazy load de imágenes fallback para navegadores antiguos
  if (!('loading' in HTMLImageElement.prototype)) {
    // Fallback para navegadores sin soporte nativo de lazy loading
    const images = document.querySelectorAll('img[loading="lazy"]');
    const imageObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const img = entry.target;
          if (img.dataset.src) {
            img.src = img.dataset.src;
            img.removeAttribute('data-src');
          }
          observer.unobserve(img);
        }
      });
    });
    
    images.forEach(img => imageObserver.observe(img));
  }

  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
